var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","fill":"currentColor","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }